import { Component, input } from '@angular/core';
import { TimezoneDto } from '@workspace/data-types';

@Component({
  selector: 'aura-internationalization-timezone-display',
  templateUrl: './internationalization-timezone-display.component.html',
  imports: [],
})
export class AuraInternationalizationTimezoneDisplayComponent {
  currentTimezone = input<TimezoneDto | null>(null);
}
